var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.699,
    height: 19.7,
    viewBox: "0 0 17.699 19.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-3.15 -2.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2719",
    "data-name": "Group 2719"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2062",
    "data-name": "Path 2062",
    d: "M20,21.85a.85.85,0,0,1-.85-.85V19A3.154,3.154,0,0,0,16,15.85H8A3.154,3.154,0,0,0,4.85,19v2a.85.85,0,1,1-1.7,0V19A4.855,4.855,0,0,1,8,14.15h8A4.855,4.855,0,0,1,20.85,19v2A.85.85,0,0,1,20,21.85Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    d: "M4-.85A4.85,4.85,0,1,1-.85,4,4.855,4.855,0,0,1,4-.85Zm0,8A3.15,3.15,0,1,0,.85,4,3.154,3.154,0,0,0,4,7.15Z",
    transform: "translate(8 3)",
    fill: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.49b1c8ae6260e6a6266531e8bb42d44d.svg";
export { ForwardRef as ReactComponent };